import { Body, Title } from "@vds/typography";
import { TextLink } from "@vds/buttons";
import ToastNotification from "../../global/components/ToastNotification";
import { Box } from "@mui/material";

import "./support.css";
import { useState } from "react";

function Support() {
    const [notification, setNotification] = useState({
    isActive: false,
    type: "success",
    message: "",
    description: "",
    style: { top: "80px" },
  });
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/assets/pdf/AssetTrackingSolutionPortalUserGuide.pdf";
    link.download = "ATS_User_Guide.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setNotification({
      isActive: true,
      type: "success",
      message: "Download guide",
      description: "User guide downloaded",
      style: { top: "80px" },
    });
    setTimeout(() => {
      setNotification((prev) => ({ ...prev, isActive: false }));
    }, 3000);
  };

  return (
    <div
      style={{
        minHeight: "75vh",
        margin: "0 auto",
        display: "row",
        flexDirection: "column",
      }}
    >
      {notification.isActive && (
        <ToastNotification
          type={notification.type}
          message={notification.message}
          description={notification.description}
          duration={1}
          style={notification.style}
        />
      )}
      <Box sx={{ p: 0, width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Title size="large" bold={false}>
            Support
          </Title>
        </div>
      </Box>
      <div
        className="ats-tab-card"
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
      >
        <div
          className="d-flex justify-content-between align-items-center my-4"
          style={{
            borderBottom: "1px solid #D8DADA",
            paddingTop: "8px",
            paddingBottom: "32px"
          }}
        >
          <div className="d-flex flex-column" style={{gap: "4px"}}>
            <Title size="small" bold={false} color="#000000">
              User guide
            </Title>
            <Body size="large" bold={false} color="#6F7171">
              Download the guide to learn how to use all features of the portal.
            </Body>
          </div>
          <TextLink
            onClick={handleDownload}
          >
            <Body size="large" bold={false} color="#000000">
            Download
            </Body>
          </TextLink>
        </div>
        <div
          className="d-flex justify-content-between align-items-center my-4"
          style={{
            paddingBottom: "24px"
          }}
        >
          <div className="d-flex flex-column" style={{gap: "4px"}}>
            <Title size="small" bold={false} color="#000000">
              Help Desk Contact Information
            </Title>
            <Body size="large" bold={false} color="#6F7171">
              Support Phone
              <br />
              <br/>
              +1(800)525-0481
              <br />
              Select 1 for all issues 
              <br/>
              <br/>
              When calling you will need the Mobile
              Device Number(MDN). The MDN can be found in the Devices list. If
              you do not have the MDN of the troubleshooted device, you may
              press the # key after making your selection in the IVR.
            </Body>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
